import apiService from '../../../services/api'

const mapHttpError = (error) => {
  const message = String(error?.message || '')

  if (message.includes('HTTP 403') || message.includes('Доступ запрещен')) {
    const mappedError = new Error('streamer_restricted')
    mappedError.code = 'streamer_restricted'
    mappedError.status = 403
    throw mappedError
  }

  if (message.includes('HTTP 404')) {
    const mappedError = new Error('round_not_found')
    mappedError.code = 'round_not_found'
    mappedError.status = 404
    throw mappedError
  }

  if (message.includes('HTTP 503')) {
    const mappedError = new Error('mode_disabled')
    mappedError.code = 'mode_disabled'
    mappedError.status = 503
    throw mappedError
  }

  throw error
}

export const wheel500Api = {
  getActiveRound: async (signal) => {
    try {
      return await apiService.makeRequest('/api/wheel50/', {
        method: 'GET',
        signal
      })
    } catch (error) {
      mapHttpError(error)
    }
  },

  getRoundById: async (roundId) => {
    try {
      const response = await apiService.makeRequest(`/api/wheel50/${roundId}/`, {
        method: 'GET'
      })

      if (response?.error) {
        const error = new Error(response.error)
        error.message = response.error
        throw error
      }

      return response
    } catch (error) {
      mapHttpError(error)
    }
  },

  getHistoryAll: async () => {
    return apiService.makeRequest('/api/wheel50/history/', {
      method: 'GET'
    })
  },

  getHistoryMine: async () => {
    return apiService.makeRequest('/api/wheel50/history/me/', {
      method: 'GET'
    })
  },

  getHistoryFast: async () => {
    return apiService.makeRequest('/api/wheel50/history/fast/', {
      method: 'GET'
    })
  },

  getBetForm: async (signal, skipBalanceSync = false) => {
    try {
      return await apiService.makeRequest('/api/wheel50/bet/', {
        method: 'GET',
        signal,
        skipBalanceSync
      })
    } catch (error) {
      mapHttpError(error)
    }
  },

  placeBet: async ({ roundId, zone, crystal, items }) => {
    const payload = {
      round_id: roundId,
      zone
    }

    if (Number(crystal || 0) > 0) {
      payload.crystal = Number(crystal)
    }

    if (Array.isArray(items) && items.length > 0) {
      payload.items = items
    }

    try {
      const response = await apiService.makeRequest('/api/wheel50/bet/', {
        method: 'POST',
        body: JSON.stringify(payload)
      })

      if (response?.error) {
        const error = new Error(response.error)
        error.message = response.error
        throw error
      }

      return response
    } catch (error) {
      mapHttpError(error)
    }
  }
}

export default wheel500Api
